<script>
export default {
  name: "resetSuccessSection",
  data() {
    return {
      email: "",
      password: "",
      viewPassword: false,
      passwordResetDialogVisible: false,
      resetEmailSentDialogVisible: false
    };
  },
  methods: {
    redirectToLoginPage() {
      this.$router.push("/newlogin");
    }
  }
};
</script>

<template>
  <el-row style="padding: 50px 16px; background-color: #2D2D2D">
    <el-col :span="24">
      <img
        class="background-image"
        loading="lazy"
        src="../../assets/AgentLoginBackground.jpg"
      />
      <div class="backdrop">
        <el-row>
          <el-col :span="24">
            <span class="sign-in-lbl">Successful Verification</span>
          </el-col>
        </el-row>
        <el-row style="width: 100%; margin-top: 16px">
          <el-col
            :span="24"
            style="padding-bottom: 16px; display: flex; flex-direction: column"
          >
            <span class="para-style">Your email address is verified.</span>
          </el-col>
        </el-row>
        <el-row style="width: 100%">
          <el-col
            :span="24"
            style="padding-bottom: 16px; display: flex; flex-direction: column"
          >
            <el-button class="btn-primary" @click="redirectToLoginPage"
              >Login</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>
</template>

<style scoped>
.sign-in-lbl {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DiNosaur-a;
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: 117.647%;
  align-self: stretch;
}

.btn-primary {
  color: #ffffff;
  text-align: center;
  border: 3px solid #003333;
  background-color: #003333;
  padding: 14px 60px;
  font: 600 20px Metropolis, sans-serif;
}

.backdrop {
  position: relative;
  padding: 20px 16px 30px 16px;
  background-color: rgba(0, 0, 0, 0.8);
}

.background-image {
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
  //z-index: -34;
}

.el-dialog--center /deep/ .el-dialog__header {
  color: #101010;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DiNosaur-a;
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: 117.647%;
}

.para-style {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DiNosaur-a;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
  align-self: stretch;
}
</style>



// WEBPACK FOOTER //
// src/components/reset/resetSuccessSection.vue